import { render, staticRenderFns } from "./NavSideBarDrawer.vue?vue&type=template&id=9089a080&"
import script from "./NavSideBarDrawer.vue?vue&type=script&lang=js&"
export * from "./NavSideBarDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports